import {
  SET_USER,
  SET_USER_DETAILS,
  SET_USER_PROFILE,
  SET_USER_TEAM,
  SET_EDITED_PROFILE,
  SET_USER_AVATAR,
  SET_TIMESTAMP
} from '../constants/actionTypes';

export const initialState = {
  user: {
    email: null,
    idDepartment: null,
    typology: null,
    name: null,
    avatarId: null,
    departmentId: null,
    username: null,
    roles: [],
    location: null,
    userId: null
  },
  logged: false,
  userDetail: null,
  userProfile: null,
  editedProfile: false,
  userTeam: null,
  timeStamp: null
};

export default (state = initialState, action) => {
  // Action payload
  const {
    type,
    user,
    userDetail,
    userProfile,
    userTeam,
    editedProfile,
    avatarId,
    timeStamp
  } = action;

  switch (type) {
    case SET_USER:
      return {
        ...state,
        user,
        logged: true
      };

    case SET_USER_DETAILS:
      return {
        ...state,
        userDetail
      };

    case SET_USER_PROFILE:
      return {
        ...state,
        userProfile
      };
    case SET_USER_TEAM:
      return {
        ...state,
        userTeam
      };
    case SET_EDITED_PROFILE:
      return {
        ...state,
        editedProfile
      };
    case SET_USER_AVATAR:
      return {
        ...state,
        user: {
          ...state.user,
          avatarId
        }
      };
    case SET_TIMESTAMP:
      return {
        ...state,
        timeStamp
      };
    default:
      return state;
  }
};
